import type { PropertyPreview } from '@dreamstack/web/lib/prisma/properties'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw from 'twin.macro'
import { TopProperty } from './TopProperty'

const StyledOffset = tw.div`mt-px-80 md:mt-px-128`

export const NearbyProperties: FunctionComponent<React.PropsWithChildren<{
  properties: PropertyPreview[]
}>> = ({ properties }) => {
  // TODO: Think about more dynamic approach for design, so that we can simply map over properties.
  const length = properties?.length ?? 0
  const prop1 = length >= 1 && properties[0]
  const prop2 = length >= 2 && properties[1]
  const prop3 = length >= 3 && properties[2]
  const prop4 = length >= 4 && properties[3]
  return (
    <div tw="flex flex-col mt-px-40 col-span-12 md:(space-x-px-48 flex-row) ml:(mt-px-96) lg:(mt-px-128 space-x-px-64)">
      <div tw="flex-1">
        {prop1 && <TopProperty property={prop1} />}
        {prop3 && (
          <StyledOffset>
            <TopProperty property={prop3} />
          </StyledOffset>
        )}
      </div>
      <div tw="flex-1">
        {prop2 && (
          <StyledOffset>
            <TopProperty property={prop2} />
          </StyledOffset>
        )}
        {prop4 && (
          <StyledOffset>
            <TopProperty property={prop4} />
          </StyledOffset>
        )}
      </div>
    </div>
  )
}
